const ferMarchands = [
  {
    id: "corniere",
    title: "Cornière",
    image: "/assets/images/products/Cornière.webp",
    specImage: "Cornière Fer marchands.webp",
    description: "Profilé en L pour assemblages et renforts structurels",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de profilés spéciaux.",
    category: "fer_marchands",
    specifications: [
      "Dimensions: de 20x20mm à 200x200mm (ailes égales)",
      "Dimensions: de 20x10mm à 200x100mm (ailes inégales)",
      "Épaisseur: de 2 à 20mm",
      "Acier S235JR ou S355JR",
      "Longueur standard: 6m"
    ]
  },
  {
    id: "fer-carre",
    title: "Fer Carré",
    image: "/assets/images/products/Fer Carré.webp",
    specImage: "Fer Carré.webp",
    description: "Barre à section carrée pour ferronnerie et constructions",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de profilés spéciaux.",
    category: "fer_marchands",
    specifications: [
      "Dimensions: de 6x6mm à 80x80mm",
      "Acier S235JR ou S355JR",
      "Finition brute de laminage",
      "Longueur standard: 6m",
      "Bonne aptitude à la soudure et à la forge"
    ]
  },
  {
    id: "fer-plat",
    title: "Fer Plat",
    image: "/assets/images/products/Fer Plat.webp",
    specImage: "Fer Plat.webp",
    description: "Barre plate polyvalente pour multiples applications métalliques",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de profilés spéciaux.",
    category: "fer_marchands",
    specifications: [
      "Largeurs: de 10 à 200mm",
      "Épaisseurs: de 3 à 40mm",
      "Acier S235JR ou S355JR",
      "Finition brute de laminage",
      "Longueur standard: 6m"
    ]
  },
  {
    id: "fer-rond",
    title: "Fer Rond",
    image: "/assets/images/products/Fer Rond.webp",
    specImage: "Fer Rond.webp",
    description: "Barre à section circulaire pour constructions et mécanismes",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de profilés spéciaux.",
    category: "fer_marchands",
    specifications: [
      "Diamètres: de 6mm à 100mm",
      "Acier S235JR ou S355JR",
      "Finition brute de laminage",
      "Longueur standard: 6m",
      "Tolérances dimensionnelles précises"
    ]
  },
  {
    id: "fer-t",
    title: "Fer T",
    image: "/assets/images/products/Fer T.webp",
    specImage: "Fer T.webp",
    description: "Profilé en forme de T pour renforts et supports",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de profilés spéciaux.",
    category: "fer_marchands",
    specifications: [
      "Hauteurs: de 20 à 100mm",
      "Largeurs d'aile: de 20 à 100mm",
      "Épaisseur: de 3 à 11mm",
      "Acier S235JR",
      "Longueur standard: 6m"
    ]
  },
  {
    id: "fer-u",
    title: "Fer U",
    image: "/assets/images/products/Fer U.webp",
    specImage: null,
    description: "Profilé en forme de U pour charpentes et supports",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de profilés spéciaux.",
    category: "fer_marchands",
    specifications: [
      "Hauteurs: de 15 à 65mm",
      "Largeurs d'ailes: de 10 à 42mm",
      "Épaisseur: de 1.5 à 5mm",
      "Acier S235JR",
      "Longueur standard: 6m"
    ]
  }
];

export default ferMarchands;
